// Google Maps shared utilities. The frontend key is exposed (browser-side
// only) via REACT_APP_GOOGLE_MAPS_API_KEY. Server-side Google calls (Geocoding,
// Distance Matrix, Places) go through /api/maps/* so the backend key stays private.
export const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "";
export const GOOGLE_MAPS_LIBRARIES = ["places"];
export const isMapsEnabled = () => !!GOOGLE_MAPS_API_KEY;
